import React, { useEffect, useRef } from 'react';
import './Hero.css';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa';

const Hero = () => {
  const heroRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = heroRef.current.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right');
    elements.forEach((el) => observer.observe(el));

    const handleVideoPlay = () => {
      if (videoRef.current) {
        videoRef.current.play().catch((error) => {
          console.log('Autoplay failed:', error);
        });
      }
    };

    if (videoRef.current) {
      videoRef.current.addEventListener('loadedmetadata', handleVideoPlay);
      videoRef.current.addEventListener('canplay', handleVideoPlay);
    }

    const handleUserInteraction = () => {
      if (videoRef.current && videoRef.current.paused) {
        videoRef.current.play().catch((error) => {
          console.log('Play on interaction failed:', error);
        });
      }
      document.removeEventListener('touchstart', handleUserInteraction);
      document.removeEventListener('click', handleUserInteraction);
    };

    document.addEventListener('touchstart', handleUserInteraction);
    document.addEventListener('click', handleUserInteraction);

    return () => {
      observer.disconnect();
      document.removeEventListener('touchstart', handleUserInteraction);
      document.removeEventListener('click', handleUserInteraction);
    };
  }, []);

  return (
    <section id="home" className="hero" ref={heroRef}>
      <video 
        ref={videoRef}
        className="hero-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        webkit-playsinline="true"
        controls={false}
        disablePictureInPicture
      >
        <source 
          src="https://res.cloudinary.com/dthbszpto/video/upload/v1750874598/V%C3%ADdeo_do_WhatsApp_de_2025-06-25_%C3%A0_s_13.24.52_17e73c7e_rpwh8c.mp4" 
          type="video/mp4"
        />
      </video>
      <div className="hero-bg"></div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-image fade-in">
            <div className="logo-container">
              <img 
                src="/logotipo/BiancaPaulino_logotipo-JUNHO2025-BRANCO.png" 
                alt="Logo Bianca Paulino"
                className="logo-image"
              />
            </div>
          </div>
          <div className="hero-text">
            <h1 className="fade-in">
              Transformando <span className="highlight">Sonhos</span> em <span className="highlight">Arquitetura</span>
            </h1>
            <p className="slide-in-left">
              Criamos espaços únicos que refletem sua personalidade e estilo de vida, 
              combinando funcionalidade, beleza e sustentabilidade em cada projeto.
            </p>
            <div className="hero-buttons slide-in-right">
              <a href="#portfolio" className="btn btn-primary">Ver Projetos</a>
              <a href="#contact" className="btn btn-whatsapp" onClick={(e) => {
                e.preventDefault();
                const phoneNumber = '5519993489551';
                const message = 'Olá! Gostaria de saber mais sobre os serviços de arquitetura.';
                const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                window.open(whatsappUrl, '_blank');
              }}>
                <FaWhatsapp className="whatsapp-icon" />
                <span>Fale Comigo no WhatsApp</span>
              </a>
              <a href="https://www.instagram.com/arq.biancapaulino/" className="btn btn-instagram">
                <FaInstagram className="whatsapp-icon" />
                Confira nosso portfólio
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;